import styles from "./premiere-salon.module.scss";
import { motion } from "framer-motion";
import {
  headingVariants,
  fadeInVariants,
  viewportSettings,
} from "../../../shared/utils/animations";

const PremiereSalon = () => {
  const BOOKING_URL = `https://www.vagaro.com/lawameraki/services`;

  return (
    <div className={`${styles["container"]}`}>
      <div
        className={`${styles["model-left-container"]} ${styles["meraki-luxury-saloon"]}`}
      >
        <motion.div
          initial="headingOffScreen"
          whileInView="headingOnScreen"
          viewport={viewportSettings}
          variants={headingVariants}
        >
          <h2>The Premier San Diego Salon</h2>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <label>
            Our stylists specialize in hand-tied extensions, color, cuts and
            more.
          </label>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p>
            Our woman founded salon is aimed to empower the beauty industry the
            Meraki Way. Our stylists specialize in hand-tied extensions, color,
            cuts, and more.
          </p>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p>
            While breaking industry boundaries, the chair becomes an experience
            where luxury and education meet. With products lines like Kevin
            Murphy , Kerestase, and Abundance Extensions.
          </p>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <p>
            We are dedicated to caring for your hair with soul, creativity, and
            love.
          </p>
        </motion.div>
        <motion.div
          initial="fadeInOffScreen"
          whileInView="fadeInOnScreen"
          viewport={viewportSettings}
          variants={fadeInVariants}
        >
          <button
            onClick={() => {
              window.open(BOOKING_URL, "_blank");
            }}
          >
            Book
          </button>
        </motion.div>
      </div>
      <div className={`${styles["model-right-container"]} `}>
        <img
          draggable={false}
          src={`https://ik.imagekit.io/euo36lugk/meraki/RevisionStudios-10_z5HWeJBBZ.jpg?updatedAt=1690001740127`}
          alt="luxury salon"
          className={`${styles["model-image"]}`}
        />
      </div>
    </div>
  );
};

export default PremiereSalon;
